<template>
  <svg
    xmlns="http://www.w3.org/2000/svg" width="22"
    height="22" viewBox="0 0 22 22"
  >
    <g data-name="그룹 168">
      <path
        data-name="제외 2"
        d="M936-1874.63a10.927 10.927 0 0 1-7.778-3.222 10.929 10.929 0 0 1-3.222-7.778 10.928 10.928 0 0 1 3.222-7.778 10.928 10.928 0 0 1 7.778-3.222 10.928 10.928 0 0 1 7.778 3.222 10.928 10.928 0 0 1 3.222 7.778 10.929 10.929 0 0 1-3.222 7.778 10.927 10.927 0 0 1-7.778 3.222zm-.008-11.682a4 4 0 0 0-3.992 3.994v2.656a.071.071 0 0 0 .071.071h7.842v-.005a.071.071 0 0 0 .071-.072v-2.65a4 4 0 0 0-3.992-3.994zm-.081-6.318a3.045 3.045 0 0 0-3.041 3.041 3.045 3.045 0 0 0 3.041 3.041 3.051 3.051 0 0 0 3.042-3.042 3.046 3.046 0 0 0-3.042-3.04z"
        transform="translate(-925 1896.63)"
      />
    </g>
  </svg>
</template>